module.exports = __webpack_public_path__ + "static/media/icon-fb.512636e2.png";